var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DynamicForm',{ref:"form",attrs:{"rules":_vm.rules,"fieldData":_vm.fieldData},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }